import React from 'react';

import { Button, ReplayIcon, Stack, Tooltip } from '@gogame/components';

const ClearButton = ({ tooltip = 'Clear filters', onClick, disabled }) => {
  return (
    <Tooltip title={tooltip} placement={'bottom'}>
      <Stack direction={'row'}>
        <Button onClick={onClick} disabled={disabled}>
          <ReplayIcon />
        </Button>
      </Stack>
    </Tooltip>
  );
};

export default ClearButton;
